module.exports = __webpack_public_path__ + "img/视频封面27.2cd172f3.png";